import shared from './FormParts.module.css';

export const RequiredStar = () => (
  <span className={shared.requiredStar} aria-hidden="true">
    *
  </span>
);

/** With `previousValue`, a changed value shows the old value in danger and the new one in success colors. */
export const SummaryValue = ({
  label,
  value,
  previousValue,
}: {
  label: string;
  value: string;
  previousValue?: string;
}) => {
  const changed = previousValue !== undefined && previousValue !== value;
  return (
    <div className={shared.summaryColumn}>
      <span className={shared.hintText}>{label}</span>
      {changed && (
        <span className={`${shared.summaryColumnValue} ${shared.previousValue}`}>
          {previousValue || '-'}
        </span>
      )}
      <span
        className={`${shared.summaryColumnValue} ${
          changed ? shared.changedValue : ''
        }`}
      >
        {value || '-'}
      </span>
    </div>
  );
};
